export const AddOrEditFormStyles = {
    form: {
        marginTop: "20px",
        paddingTop: "20px",
    },
    formActions: {
        diplay:"flex",
        marginTop: 2,
        marginBottom: 2,
        justifyContent: "flex-end"
    },
    textFieldStyle: {
        '& > :not(style)': {
            m:1,
            width: "25ch"
        },
        mb: 2
    },
    containerTextFields: {
        display:"flex",
        flexDirection: "row"
    }
}